module.exports = __webpack_public_path__ + "img/premier_white.aea3eae6.svg";